<template>
  <div style="clear: both; max-width: 700px; margin: 10px auto" class="d-flex">
    <!-- left -->
    <div :class="{ 'mr-10': $vuetify.breakpoint.mdAndUp, 'mr-3': $vuetify.breakpoint.xs, 'mr-6': $vuetify.breakpoint.sm }" :style="{ 'min-width': $vuetify.breakpoint.smAndDown ? '80px' : '100px' }">
      <img src="@/assets/Testimonial.png" alt="Testimonial Image" :style="{ 'width': $vuetify.breakpoint.smAndDown ? '100%' : '100%' }" class="pt-2">
    </div>

    <div>
      <p :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '14px' : '18px' }" class="mb-0">
        {{ data.text }}
      </p>
      <p style="color: lightgrey" :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '12px' : '14px' }">
        {{ data.author }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>
